import React from "react";
import { Box, Typography } from "@mui/material";
import { TEXT_COLOR_PRIMARY } from "../../../constants/colors";
import { FONT_SIZE } from "../../../constants/fontSizes";

/**
 * ヒューマンスキルの説明文一覧
 */
const HumanSkillDescriptions = ({ humanSkills }) => {
  return (
    <Box>
      {humanSkills.map((humanSkill) => (
        <Box
          key={humanSkill.key}
          sx={{
            display: "flex",
            flexDirection: "column",
            mb: 2,
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: TEXT_COLOR_PRIMARY,
              fontWeight: "bold",
              fontSize: FONT_SIZE.XS,
            }}
          >
            {humanSkill.label}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: TEXT_COLOR_PRIMARY,
              fontSize: FONT_SIZE.XS,
              lineHeight: 1.6,
            }}
          >
            {humanSkill.description}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default HumanSkillDescriptions;
